import React from 'react';
import { ArrowRight, ArrowUpRight } from 'lucide-react';
import { motion } from 'framer-motion';
import { Stagger, Item } from './motion';
import { viewportOnce } from '../lib/motion';
import { scrollToId } from '../lib/scroll';

const products = [
  {
    name: 'Ortexo',
    tag: 'Cercetare juridică, fiscală și contabilă',
    page: 'ortexo',
    description:
      'Întrebi în limbaj obișnuit și primești răspunsul cu trimiterea exactă la lege — articolul pe care îl deschizi și îl citezi. Baza este actualizată din Monitorul Oficial, așa că lucrezi implicit cu forma în vigoare.',
    points: [
      'Legislație, Cod fiscal și TVA, norme contabile OMFP',
      'Jurisprudență, inclusiv ÎCCJ — decizii de RIL și hotărâri prealabile',
      'Legea de azi sau forma ei la o dată din trecut',
      'Se conectează la Claude și ChatGPT, cu acces doar-citire',
    ],
    external: [
      { label: 'Deschide aplicația', href: 'https://app.ortexo.com' },
      { label: 'ortexo.com', href: 'https://ortexo.com' },
    ],
  },
  {
    name: 'Borderou',
    tag: 'Dosare, registru, timp și facturi',
    page: 'borderou',
    description:
      'Urmărește dosarele tale pe portal.just.ro și aduce fiecare termen nou direct în calendar. Registrul de ieșiri se completează și se numerotează singur, din documentele expediate — fără salturi și fără scris de mână.',
    points: [
      'Verificare automată pe portal.just.ro, inclusiv noaptea',
      'Termene și ședințe direct în calendar, cu notificări',
      'Dosare noi apărute pe portal, preluate automat',
      'Evidența timpului și facturare, cu export PDF',
    ],
    external: [{ label: 'Deschide aplicația', href: 'https://borderou.polytooldesign.com' }],
  },
  {
    name: 'Plicuri',
    tag: 'Corespondență de insolvență — în lansare',
    page: 'corespondenta',
    waitlist: true,
    description:
      'Încarci sentința și lista de creditori, iar Plicuri pregătește întreaga corespondență cu datele completate: plicuri, notificări, confirmări de primire și borderoul de expediere. Tu verifici în previzualizare și tipărești.',
    points: [
      'Sentința citită de un model AI procesat în Uniunea Europeană',
      'Adrese din ANAF după CUI, sau din VIES pentru firme străine',
      'Instituțiile uzuale — ANAF, AAAS, primării, DGITL — adăugate automat',
      'Credite care nu expiră, fără abonament; primele 15 sunt gratuite',
    ],
    external: [],
  },
];

export const Products = ({ onNavigate }) => {
  const go = (e, page) => {
    e.preventDefault();
    if (onNavigate) onNavigate(page);
  };

  const goContact = (e) => {
    e.preventDefault();
    scrollToId('#contact');
  };

  return (
    <section id="produse" className="section section-elevated">
      <div className="container">
        <Stagger>
          <Item as="h2" className="hm-h2">
            Trei aplicații pentru <span className="accent">munca de cabinet.</span>
          </Item>
          <Item as="p" className="hm-sub">
            Fiecare rezolvă complet o problemă concretă și poate fi folosită singură. Împreună,
            acoperă drumul de la cercetare până la documentul expediat.
          </Item>
        </Stagger>

        <div className="pr-list">
          {products.map((p) => (
            /* Each row reveals on its own, so the list unrolls as you scroll it */
            <Stagger key={p.name} as="article" className="pr-row">
              <Item>
                <h3 className="pr-name">{p.name}</h3>
                <span className="pr-tag">{p.tag}</span>
              </Item>

              <Item className="pr-body">
                <p className="pr-desc">{p.description}</p>

                <div className="pr-points">
                  {p.points.map((point, i) => (
                    <div key={point} className="pr-point">
                      <motion.span
                        className="bar"
                        initial={{ scaleX: 0 }}
                        whileInView={{ scaleX: 1 }}
                        viewport={viewportOnce}
                        transition={{
                          duration: 0.55,
                          delay: 0.35 + i * 0.08,
                          ease: [0.16, 1, 0.3, 1],
                        }}
                      />
                      {point}
                    </div>
                  ))}
                </div>

                <div className="pr-links">
                  <a href={`/${p.page}`} onClick={(e) => go(e, p.page)} className="pr-link">
                    Vezi {p.name} <ArrowRight size={15} />
                  </a>
                  {p.external.map((link) => (
                    <a
                      key={link.href}
                      href={link.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="pr-link muted"
                    >
                      {link.label} <ArrowUpRight size={15} />
                    </a>
                  ))}
                  {p.waitlist && (
                    <a href="/#contact" onClick={goContact} className="pr-link muted">
                      Înscrie-te pe lista de așteptare <ArrowRight size={15} />
                    </a>
                  )}
                </div>
              </Item>
            </Stagger>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Products;
